import Section from "@bmi-digital/components/section";
import React from "react";
import {
  FooterMainNavigationBlockSitemap,
  InternalOrExternalLinkBlockSitemapBlock,
  MenuNavigationBlockSitemap
} from "./SitemapBlock";
import type { SiteData } from "./Site";

export const MenuNavigationSiteMapSection = ({
  menuNavigation,
  menuNavigationSiteMapTitle
}: Pick<SiteData, "menuNavigation" | "menuNavigationSiteMapTitle">) => {
  return (
    <Section id="site-map" data-testid="sitemap-section-menu-navigation">
      <Section.Title>{menuNavigationSiteMapTitle}</Section.Title>
      <MenuNavigationBlockSitemap links={menuNavigation} />
    </Section>
  );
};

interface MenuUtilitiesSiteMapSectionProps {
  menuUtilities: NonNullable<SiteData["menuUtilities"]>;
  menuUtilitiesSiteMapTitle: NonNullable<SiteData["menuUtilitiesSiteMapTitle"]>;
}

export const MenuUtilitiesSiteMapSection = ({
  menuUtilities,
  menuUtilitiesSiteMapTitle
}: MenuUtilitiesSiteMapSectionProps) => {
  return (
    <Section id="site-map" data-testid="sitemap-section-menu-utilities">
      <Section.Title>{menuUtilitiesSiteMapTitle}</Section.Title>
      <InternalOrExternalLinkBlockSitemapBlock links={menuUtilities} />
    </Section>
  );
};

interface FooterMainNavigationSiteMapSectionProps {
  footerMainNavigation: NonNullable<SiteData["footerMainNavigation"]>;
  footerMainNavigationSiteMapTitle: NonNullable<
    SiteData["footerMainNavigationSiteMapTitle"]
  >;
}

export const FooterMainNavigationSiteMapSection = ({
  footerMainNavigation,
  footerMainNavigationSiteMapTitle
}: FooterMainNavigationSiteMapSectionProps) => {
  return (
    <Section id="site-map" data-testid="sitemap-section-footer-main-navigation">
      <Section.Title>{footerMainNavigationSiteMapTitle}</Section.Title>
      <FooterMainNavigationBlockSitemap data={footerMainNavigation} />
    </Section>
  );
};

interface FooterSecondaryNavigationSiteMapSectionProps {
  footerSecondaryNavigation: NonNullable<SiteData["footerSecondaryNavigation"]>;
  footerSecondaryNavigationSiteMapTitle: NonNullable<
    SiteData["footerSecondaryNavigationSiteMapTitle"]
  >;
}

export const FooterSecondaryNavigationSiteMapSection = ({
  footerSecondaryNavigation,
  footerSecondaryNavigationSiteMapTitle
}: FooterSecondaryNavigationSiteMapSectionProps) => {
  return (
    <Section
      id="site-map"
      data-testid="sitemap-section-footer-secondary-navigation"
    >
      <Section.Title>{footerSecondaryNavigationSiteMapTitle}</Section.Title>
      <InternalOrExternalLinkBlockSitemapBlock
        links={footerSecondaryNavigation}
      />
    </Section>
  );
};
